<div class="">
  <mat-form-field class="autocomplete-container" appearance="outline">
    <mat-label>Select Stakeholders</mat-label>
  <mat-select #matSelect>
    <input
    #inputFieldStakeholder
    (keydown)="onKeyDown($event)"
    [formControl]="stakeholderControl"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keydown.enter)="addStakeholder(inputFieldStakeholder.value); matSelect.close();"
    placeholder="Search Stakeholders or Create"
    class="search-input sticky top-[0px] z-50 !bg-[#ffffff] placeholder-[#868E96]"
  />
    <mat-option class="hover:!bg-[#fae8e1] border-b " *ngFor="let stakeholder of filteredStakeholders | async" (click)="onSelectionChange(stakeholder)">
      {{ stakeholder }}
    </mat-option>
  </mat-select>
</mat-form-field>
  <div class="mt-[25px]">
    <ul>
      <div class="flex" *ngFor="let stakeholder of selectedStakeholders">
        <p>
          {{ stakeholder }}
        </p>

        <button
          type="button"
          class="justify-start"
          (click)="remove(stakeholder)"
          style="margin-top :-0.25rem; margin-left:0.625rem;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 12 12"
            fill="none"
          >
            <g filter="url(#filter0_d_4054_30471)">
              <ellipse
                cx="5.7573"
                cy="3.99989"
                rx="3.7573"
                ry="3.99989"
                fill="white"
              />
              <path
                d="M9.01461 3.99989C9.01461 5.96276 7.52726 7.49978 5.7573 7.49978C3.98735 7.49978 2.5 5.96276 2.5 3.99989C2.5 2.03702 3.98735 0.5 5.7573 0.5C7.52726 0.5 9.01461 2.03702 9.01461 3.99989Z"
                stroke="#AAD4F5"
                stroke-opacity="0.15"
              />
            </g>
            <path
              d="M4.31152 5.53875L7.20176 2.46191M4.31152 2.46191L7.20176 5.53875"
              stroke="#868E96"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <defs>
              <filter
                id="filter0_d_4054_30471"
                x="0"
                y="0"
                width="11.5146"
                height="12"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_4054_30471"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_4054_30471"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
    </ul>
  </div>
</div>
